import React from "react";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng
} from "react-places-autocomplete";
import {formStyle} from "./style";
import {translate} from "admin-on-rest";

class LocationSearchInputBase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      address: "",
      errorMessage: "",
      latitude: null,
      longitude: null,
      isGeocoding: false
    };
  }

  handleChange = address => {
    this.setState({
      address,
      latitude: null,
      longitude: null,
      errorMessage: ""
    });
  };

  handleSelect = selected => {
    this.setState({isGeocoding: true, address: selected});
    geocodeByAddress(selected)
      .then(res => getLatLng(res[0]))
      .then(({lat, lng}) => {
        this.setState({
          latitude: lat,
          longitude: lng,
          isGeocoding: false
        });
        this.props.onCenterChanged(this.state.latitude, this.state.longitude);
        this.props.onPlaceSelected({
          address: this.state.address,
          lat: this.state.latitude,
          lng: this.state.longitude
        });
      })
      .catch(error => {
        this.setState({isGeocoding: false});
        console.log("error", error); // eslint-disable-line no-console
      });
  };

  handleCloseClick = () => {
    this.setState({
      address: "",
      latitude: null,
      longitude: null
    });
  };

  handleError = (status, clearSuggestions) => {
    console.log("Error from Google Maps API", status); // eslint-disable-line no-console
    this.setState({errorMessage: status}, () => {
      clearSuggestions();
    });
  };

  render() {
    const {address} = this.state;
    const {translate} = this.props;

    return (
      <PlacesAutocomplete
        value={address}
        onChange={this.handleChange}
        onSelect={this.handleSelect}
        onError={this.handleError}
        debounce={300}
        shouldFetchSuggestions={address.length > 3}
      >
        {({getInputProps, suggestions, getSuggestionItemProps, loading}) => (
          <div style={formStyle.locationSearchInput.container}>
            <div>
              <input
                {...getInputProps({
                  placeholder: translate("resources.stores.inputs.placeSearch")
                })}
                style={formStyle.locationSearchInput.input}
              />
              {this.state.address.length > 0 && (
                <button
                  style={formStyle.locationSearchInput.button}
                  onClick={this.handleCloseClick}
                >
                  x
                </button>
              )}
            </div>
            <div style={formStyle.locationSearchInput.suggestionsContainer}>
              {loading && (
                <div style={formStyle.locationSearchInput.loading}>
                  {translate("resources.stores.inputs.loading")}
                </div>
              )}
              {suggestions.map(suggestion => {
                const className = suggestion.active
                  ? "suggestion-item--active"
                  : "suggestion-item";

                const style = suggestion.active
                  ? formStyle.locationSearchInput.suggestions.selected
                  : formStyle.locationSearchInput.suggestions.other;
                return (
                  <div
                    {...getSuggestionItemProps(suggestion, {
                      className,
                      style
                    })}
                  >
                    <span>{suggestion.description}</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </PlacesAutocomplete>
    );
  }
}

const LocationSearchInput = translate(LocationSearchInputBase);

export default LocationSearchInput;



// WEBPACK FOOTER //
// ./src/containers/CRM/Stores/LocationSearchInput.js